import React from "react";
import CustomSidebarToggleButton from "./components/CustomSidebarToggleButton";
import { useWindowDimensions } from "../../utils/dimensionHook";

const CustomAppBar = () => {
  const { width } = useWindowDimensions();

  return <div>{width < 600 ? <CustomSidebarToggleButton /> : <></>}</div>;
};

export default CustomAppBar;
